import React from 'react'
import "../styles/Skills.css"
import { skills } from '../details/data'
import SkillTile from "./SkillTile"

function Skills() {
  return (
    <section id='skills' className='skills'>
      <h1 className='skillName'>Skills</h1>
      <p className='skillDesc'>Here are some of my skills on which I have been working on.</p>
      <div className="skillContainer">
        {skills.map((skill) => (<SkillTile key={skill.title} name={skill.title} skills={skill.skills}/>))}
      </div>
    </section>
  )
}

export default Skills
